import iconLogo from 'assets/img/common/img/icon-logo.svg';
import iconSuccess from 'assets/img/common/img/icon-success.svg';
import iconUnbeatable from 'assets/img/sign-up/img/icon-unbeatable.svg';
import iconJoin from 'assets/img/sign-up/img/icon-join.svg';

export const images = {
    logo: iconLogo,
    success: iconSuccess,
    unbeatable: iconUnbeatable,
    join: iconJoin,
};